<script lang="ts">
    import { Col, Image } from "sveltestrap";
    import { href, Print } from "../../../utils/Constant/Constant";
    import Link from "svelte-link";
    import {usersData} from "../../../store"
    import EmailGeneral from "./EmailGeneral.svelte";
    let imgpath:string = "/assets/images/user"
    let setUsersData
    usersData.subscribe((value)=>{
        setUsersData = value
    })
</script>
<Col xl="8" md="7" class="xl-50 box-col-6">
    <div class="tab-content" id="v-pills-tabContent1">
        <div class="tab-pane fade show active">
            <div class="profile-mail">
                <div class="media">
                    <Image fluid class="img-100 m-r-20 rounded-circle update_img_5" src="{imgpath}/{setUsersData.img}" alt="" />
                    <div class="media-body mt-0">
                        <h5>
                            <span class="first_name_5">{setUsersData.name} </span>
                        </h5>
                        <p class="email_add_5">{setUsersData.email}</p>
                        <ul>
                            <li>
                                <Link href={href} >{Print}</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <EmailGeneral />
            </div>
        </div>
    </div>
</Col>